// ---------- Shared: refresh cart-drawer + cart-icon-bubble, then open drawer ----------
async function trbsRefreshCartUI() {
  var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
 
  var cartDrawer = document.querySelector('cart-drawer');
  var cartIconBubble = document.getElementById('cart-icon-bubble');
 
  try {
    var sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
    var sectionsHtml = await sectionsRes.json();
    var parser = new DOMParser();
 
    if (sectionsHtml['cart-drawer'] && cartDrawer) {
      var newDoc = parser.parseFromString(sectionsHtml['cart-drawer'], 'text/html');
      var newDrawer = newDoc.querySelector('cart-drawer');
      if (newDrawer) {
        cartDrawer.className = newDrawer.className;
 
        Array.prototype.forEach.call(newDrawer.attributes, function (attr) {
          cartDrawer.setAttribute(attr.name, attr.value);
        });
 
        Array.prototype.slice.call(cartDrawer.attributes).forEach(function (attr) {
          if (!newDrawer.hasAttribute(attr.name)) {
            cartDrawer.removeAttribute(attr.name);
          }
        });
 
        cartDrawer.innerHTML = newDrawer.innerHTML;
      } else {
        console.warn('cart-drawer tag not found inside fetched section HTML.');
      }
    } else {
      console.warn('sectionsHtml["cart-drawer"] missing — section id mismatch.');
    }
 
    if (sectionsHtml['cart-icon-bubble'] && cartIconBubble) {
      var bubbleDoc = parser.parseFromString(sectionsHtml['cart-icon-bubble'], 'text/html');
      var newBubble = bubbleDoc.querySelector('#cart-icon-bubble');
      var sourceHtml = null;
 
      if (newBubble) {
        sourceHtml = newBubble.outerHTML;
      } else {
        var wrapper = bubbleDoc.querySelector('#shopify-section-cart-icon-bubble') || bubbleDoc.body;
        if (wrapper) sourceHtml = wrapper.innerHTML;
      }
 
      if (sourceHtml) {
        if (newBubble) {
          cartIconBubble.className = newBubble.className;
          Array.prototype.forEach.call(newBubble.attributes, function (attr) {
            cartIconBubble.setAttribute(attr.name, attr.value);
          });
        }
        cartIconBubble.innerHTML = newBubble ? newBubble.innerHTML : sourceHtml;
      } else {
        console.warn('Could not extract cart-icon-bubble content from section HTML.');
      }
    }
  } catch (err) {
    console.warn('Section re-render failed:', err);
  }
 
  if (cartDrawer && typeof cartDrawer.open === 'function') {
    cartDrawer.open();
  }
 
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } })
  );
 
  return cart;
}
 
// ---------- Handler 1: custom "Add To Cart" buttons (data-variant-id) ----------
// Uses document-level delegation instead of a "section" variable so this works
// on ANY page (collection page, best-sellers slider, etc.) without a ReferenceError.
document.addEventListener('click', async function (e) {
  var btn = e.target.closest('.trbs-add-to-cart');
  if (!btn) return;
 
  var variantId = btn.dataset.variantId;
 
  try {
    btn.disabled = true;
    btn.innerText = 'Adding...';
 
    var addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
 
    if (!addRes.ok) throw new Error('Add to cart failed');
 
    await trbsRefreshCartUI();
 
    btn.innerText = 'Added';
    setTimeout(function () {
      btn.innerText = 'Add To Cart';
      btn.disabled = false;
    }, 1500);
  } catch (error) {
    console.error(error);
    btn.innerText = 'Error';
    setTimeout(function () {
      btn.innerText = 'Add To Cart';
      btn.disabled = false;
    }, 1500);
  }
});
 
// ---------- Handler 2: native Shopify {% form 'product' %} forms (trbs-native-add-form) ----------
document.addEventListener('submit', async function (e) {
  var form = e.target.closest('.trbs-native-add-form');
  if (!form) return;
 
  e.preventDefault();
 
  var submitBtn = form.querySelector('.trbs-native-add-btn');
  var formData = new FormData(form);
 
  try {
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.originalText = submitBtn.dataset.originalText || submitBtn.innerText;
      submitBtn.innerText = 'Adding...';
    }
 
    var addRes = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    });
 
    if (!addRes.ok) throw new Error('Add to cart failed');
 
    await trbsRefreshCartUI();
 
    if (submitBtn) {
      submitBtn.innerText = 'Added';
      setTimeout(function () {
        submitBtn.innerText = submitBtn.dataset.originalText;
        submitBtn.disabled = false;
      }, 1500);
    }
  } catch (error) {
    console.error(error);
    if (submitBtn) {
      submitBtn.innerText = 'Error';
      setTimeout(function () {
        submitBtn.innerText = submitBtn.dataset.originalText;
        submitBtn.disabled = false;
      }, 1500);
    }
  }
});